import { render, staticRenderFns } from "./StatisticsForm.vue?vue&type=template&id=62e867fa&scoped=true"
import script from "./StatisticsForm.vue?vue&type=script&lang=js"
export * from "./StatisticsForm.vue?vue&type=script&lang=js"
import style0 from "./StatisticsForm.vue?vue&type=style&index=0&id=62e867fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e867fa",
  null
  
)

export default component.exports